/**
 * Paid order lines only — gifts are add-ons and must not affect catalog mix / counts.
 */
export const getOrderPaidProducts = (products) =>
  (Array.isArray(products) ? products : []).filter((product) => !product?.isGift)

export default getOrderPaidProducts
